import React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { BaseRoutes } from "./BaseRoutes";

import { ForgotPassword } from "../pages/ForgotPassword";
import { Home } from "../pages/Home";
import { Login } from "../pages/Login";

import { HomeParamsProvider } from "hooks/usePagesParams/useHomeParams";
import { SellersParamsProvider } from "hooks/usePagesParams/useSellersParams";
import { AccountDeletions } from "pages/AccountDeletions";
import { CustomerDetails } from "pages/CustomerDetails";
import { Events } from "pages/Events";
import { EventDetails } from "pages/Events/EventDetails";
import { EventNew } from "pages/Events/EventNew";
import { ExhibitorEdit } from "pages/Events/ExhibitorEdit";
import { ExhibitorNew } from "pages/Events/ExhibitorNew";
import { FaqEdit } from "pages/Events/FaqEdit";
import { FaqNew } from "pages/Events/FaqNew";
import { LocationEdit } from "pages/Events/LocationEdit";
import { LocationNew } from "pages/Events/LocationNew";
import { RegistrationEdit } from "pages/Events/RegistrationEdit";
import { RegistrationNew } from "pages/Events/RegistrationNew";
import { SessionEdit } from "pages/Events/SessionEdit";
import { SessionNew } from "pages/Events/SessionNew";
import { TrackEdit } from "pages/Events/TrackEdit";
import { TrackNew } from "pages/Events/TrackNew";
import { InternalStore } from "pages/InternalStore";
import { NewRole } from "pages/Permissions/NewRole";
import { NewUser } from "pages/Permissions/NewUser";
import { RoleDetails } from "pages/Permissions/RoleDetails";
import { UserDetails } from "pages/Permissions/UserDetails";
import { Sellers } from "pages/Sellers";
import { SellerDetails } from "pages/Sellers/SellerDetails";
import { SellersLeads } from "pages/Sellers/SellersLeads";
import { SellerLeadDetails } from "pages/Sellers/SellersLeads/SellerLeadDetails";
import { SellerLeadNew } from "pages/Sellers/SellersLeads/SellerLeadNew";
import { TicketIngestions } from "pages/TicketIngestions";
import { TicketIngestionDetails } from "pages/TicketIngestions/TicketIngestionDetails";
import { TicketIngestionBatchPayload } from "pages/TicketIngestions/TicketIngestionBatchPayload";
import { Permissions } from "../pages/Permissions";
import { PrivateRoute } from "./PrivateRoute";

export const Routes: React.FC = () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path={BaseRoutes.login} component={Login} />
        <Route
          exact
          path={BaseRoutes.fogotPassword}
          component={ForgotPassword}
        />

        <Route exact path={[BaseRoutes.home, BaseRoutes.customerDetails]}>
          <HomeParamsProvider>
            <PrivateRoute exact path={BaseRoutes.home} component={Home} />
            <PrivateRoute
              exact
              path={BaseRoutes.customerDetails}
              component={CustomerDetails}
            />
          </HomeParamsProvider>
        </Route>

        <PrivateRoute exact path={BaseRoutes.home} component={Home} />
        <PrivateRoute
          exact
          path={BaseRoutes.customerDetails}
          component={CustomerDetails}
        />

        <PrivateRoute
          exact
          path={BaseRoutes.sellersLeads}
          component={SellersLeads}
        />
        <PrivateRoute
          exact
          path={BaseRoutes.sellersLeadCreate}
          component={SellerLeadNew}
        />
        <PrivateRoute
          exact
          path={BaseRoutes.sellersLeadEdit}
          component={SellerLeadDetails}
        />

        <Route exact path={[BaseRoutes.sellers, BaseRoutes.sellerDetails]}>
          <SellersParamsProvider>
            <PrivateRoute exact path={BaseRoutes.sellers} component={Sellers} />
            <PrivateRoute
              exact
              path={BaseRoutes.sellerDetails}
              component={SellerDetails}
            />
          </SellersParamsProvider>
        </Route>

        <PrivateRoute
          exact
          path={BaseRoutes.permissions}
          component={Permissions}
        />
        <PrivateRoute exact path={BaseRoutes.newUser} component={NewUser} />
        <PrivateRoute exact path={BaseRoutes.newRole} component={NewRole} />
        <PrivateRoute
          exact
          path={BaseRoutes.userDetails}
          component={UserDetails}
        />
        <PrivateRoute
          exact
          path={BaseRoutes.roleDetails}
          component={RoleDetails}
        />
        <Route
          exact
          path={BaseRoutes.internalStore}
          component={InternalStore}
        />

        <PrivateRoute exact path={BaseRoutes.events} component={Events} />
        <PrivateRoute
          exact
          path={BaseRoutes.eventCreate}
          component={EventNew}
        />
        <PrivateRoute
          exact
          path={BaseRoutes.eventDetails}
          component={EventDetails}
        />
        <PrivateRoute
          exact
          path={BaseRoutes.exhibitorCreate}
          component={ExhibitorNew}
        />
        <PrivateRoute
          exact
          path={BaseRoutes.exhibitorEdit}
          component={ExhibitorEdit}
        />
        <PrivateRoute exact path={BaseRoutes.faqCreate} component={FaqNew} />
        <PrivateRoute exact path={BaseRoutes.faqEdit} component={FaqEdit} />
        <PrivateRoute
          exact
          path={BaseRoutes.sessionCreate}
          component={SessionNew}
        />
        <PrivateRoute
          exact
          path={BaseRoutes.sessionEdit}
          component={SessionEdit}
        />
        <PrivateRoute
          exact
          path={BaseRoutes.trackCreate}
          component={TrackNew}
        />
        <PrivateRoute exact path={BaseRoutes.trackEdit} component={TrackEdit} />
        <PrivateRoute
          exact
          path={BaseRoutes.locationCreate}
          component={LocationNew}
        />
        <PrivateRoute
          exact
          path={BaseRoutes.locationEdit}
          component={LocationEdit}
        />
        <PrivateRoute
          exact
          path={BaseRoutes.registrationCreate}
          component={RegistrationNew}
        />
        <PrivateRoute
          exact
          path={BaseRoutes.registrationEdit}
          component={RegistrationEdit}
        />

        <PrivateRoute
          exact
          path={BaseRoutes.accountDeletions}
          component={AccountDeletions}
        />

        <PrivateRoute
          exact
          path={BaseRoutes.ticketIngestions}
          component={TicketIngestions}
        />
        <PrivateRoute
          exact
          path={BaseRoutes.ticketIngestionDetails}
          component={TicketIngestionDetails}
        />
        <PrivateRoute
          exact
          path={BaseRoutes.ticketIngestionBatchPayload}
          component={TicketIngestionBatchPayload}
        />

        <PrivateRoute exact path={BaseRoutes.account} component={UserDetails} />
        <Route component={Login} />
      </Switch>
    </BrowserRouter>
  );
};
